<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-8 text-center">
          <v-icon color="error" size="64" class="mb-4">
            mdi-lock
          </v-icon>
          
          <v-card-title class="text-h5 mb-4 text-center">
            Доступ запрещён
          </v-card-title>
          
          <v-card-text class="text-body-1 mb-4">
            У вас недостаточно прав для доступа к этой странице. 
            Пожалуйста, обратитесь к администратору, если считаете, что это ошибка.
          </v-card-text>
          
          <v-btn
            color="primary"
            size="large"
            variant="elevated"
            :to="'/'"
            block
          >
            На главную
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AccessDenied'
};
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>